import BUApi from './_buApi';
import httpClient from '@/apis/base/httpclient';

class buPlanReceiptAPI extends BUApi {
  constructor() {
    super();
  }
  controllerName = 'BUPlanReceipts';
}
export default new buPlanReceiptAPI();
